
import { db } from '@/lib/firebase';
import { collection, addDoc, serverTimestamp, getDocs, writeBatch, doc } from 'firebase/firestore';

const NAMES = [
    // 한국인 실명 및 닉네임 기반
    '김민준_K', '이지은92', '박서윤_Trade', '최도윤_Swap', '강지아_Coin',
    '윤준서_KR', '신하윤_Pro', '임건우_Official', '한소희_Safe', '오지훈_Vip',
    '서다은_Crypto', '코인깎는노인', '강남고래', '여의도큰손', '제테크왕최박사',
    '블록체인사랑', '디지털노마드K', '안전제일_장터', '칼국수조아', '민트초코코인',
    // 글로벌 닉네임 기반
    'Crypto_King7', 'Whale_Watcher', 'Alpha_Trader', 'Lunar_Swap', 'Mars_Invest',
    'Pixel_Prophet', 'Aura_Exchange', 'Nexus_P2P', 'Infinity_Trade', 'Zenith_Coin',
    'Echo_Trader', 'Solar_System', 'Gravity_Fx', 'Pulse_P2P', 'Cyber_Punk_K',
    'Velocity_Trade', 'Titan_Invest', 'Arcade_Swap', 'Bit_Master_X', 'Ethereum_Dev',
    // 기업/기관형 사칭 방지 일반형
    'Verified_Seller_01', 'QuickSwap_Global', 'SafeGate_Exchange', 'Premium_Vendor_K',
    'Instant_OTC_Trade', 'Reliable_Market_X', 'Global_Escrow_P2P', 'Turbo_Trade_99',
    'Star_Trader_Kr', 'Golden_Bull_Invest'
];
const ASSETS = ['USDT', 'BTC', 'ETH', 'TRX'];

/**
 * P2P 광고 샘플 데이터를 생성합니다.
 * @param count 생성할 광고 개수
 */
export const seedP2PAds = async (count: number = 3): Promise<void> => {
    try {
        const batch = writeBatch(db);
        const p2pCollection = collection(db, 'p2p_ads');

        for (let i = 0; i < count; i++) {
            const type = Math.random() > 0.5 ? 'BUY' : 'SELL';
            const asset = ASSETS[Math.floor(Math.random() * ASSETS.length)];
            const advertiserName = NAMES[Math.floor(Math.random() * NAMES.length)];

            // 자산별 합리적인 가격대 설정 (KRW 기준)
            let price = 0;
            if (asset === 'USDT') price = 1430 + Math.random() * 30;
            else if (asset === 'BTC') price = 135000000 + Math.random() * 5000000;
            else if (asset === 'ETH') price = 3800000 + Math.random() * 200000;
            else if (asset === 'TRX') price = 200 + Math.random() * 50;

            const available = 100 + Math.random() * 5000;
            const limitMin = 50000 + Math.random() * 100000;
            const limitMax = limitMin + 2000000 + Math.random() * 30000000;

            const rating = parseFloat((4.3 + Math.random() * 0.7).toFixed(1));
            const trades = Math.floor(50 + Math.random() * 5000);
            const status = 'Active';

            const adData = {
                type,
                advertiserName,
                asset,
                price: parseFloat(price.toFixed(2)),
                available: parseFloat(available.toFixed(2)),
                limitMin: Math.floor(limitMin / 1000) * 1000,
                limitMax: Math.floor(limitMax / 1000) * 1000,
                rating,
                trades,
                status,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            };

            const newDocRef = doc(p2pCollection);
            batch.set(newDocRef, adData);
        }

        await batch.commit();
        console.log(`Successfully seeded ${count} P2P ads!`);
    } catch (error) {
        console.error('P2P Seeding error:', error);
        throw error;
    }
};

/**
 * 모든 P2P 광고 데이터를 삭제합니다. (초기화용)
 */
export const clearP2PAds = async (): Promise<void> => {
    try {
        const snapshot = await getDocs(collection(db, 'p2p_ads'));
        const batch = writeBatch(db);
        snapshot.docs.forEach((doc) => {
            batch.delete(doc.ref);
        });
        await batch.commit();
        console.log('Successfully cleared all P2P ads!');
    } catch (error) {
        console.error('Clear P2P error:', error);
        throw error;
    }
};
